import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import toast from 'react-hot-toast';

export const Auth0Callback: React.FC = () => {
  const auth0 = useAuth0();
  const { isLoading, error, isAuthenticated } = auth0;
  const navigate = useNavigate();
  const { state } = useAuth();

  useEffect(() => {
    if (!isLoading) {
      if (error) {
        // Stay on this page so the error below is visible
        console.error('Auth0 callback error:', error);
      } else if (isAuthenticated) {
        toast.success('Successfully logged in with Auth0!');
        // Give AuthContext a moment to process the user, then redirect
        setTimeout(() => {
          navigate('/');
        }, 1000);
      } else {
        // Not authenticated, redirect to login
        navigate('/login');
      }
    }
  }, [isLoading, error, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full space-y-8 text-center">
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-primary-600">
            <span className="text-white font-bold text-xl">RL</span>
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-900">Completing login...</h2>
            <div className="mt-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full space-y-8 text-center">
          <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-red-600">
            <span className="text-white font-bold text-xl">!</span>
          </div>
          <div>
            <h2 className="text-2xl font-bold text-gray-900">Authentication Error</h2>
            <p className="mt-2 text-gray-600">{error.message}</p>
            <button
              onClick={() => navigate('/login')}
              className="mt-4 px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700"
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};